import { Link } from "react-router";
import { Loader2, BarChart3, ChevronRight } from "lucide-react";
import { useDashboards } from "@/hooks/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function DashboardsListPage() {
  const { data, isLoading, isError, error } = useDashboards();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold">Dashboards</h1>
        <p className="text-sm text-admin-text-secondary mt-1">
          Skreddersydde rapporter for produkt-team. Hver dashboard er kodet for
          hånd og kan kjøres med ferske filtre.
        </p>
      </div>

      {isLoading && (
        <div className="flex items-center gap-2 text-sm text-admin-text-secondary">
          <Loader2 className="h-4 w-4 animate-spin" /> Laster…
        </div>
      )}

      {isError && (
        <div className="rounded-md border border-admin-danger-500/30 bg-admin-danger-500/5 p-4 text-sm text-admin-danger-400">
          {error?.message || "Kunne ikke hente dashboards"}
        </div>
      )}

      {data && data.length === 0 && (
        <p className="text-sm text-admin-text-subtle">Ingen dashboards registrert ennå.</p>
      )}

      <div className="grid gap-4 sm:grid-cols-2">
        {data?.map((d) => (
          <Link key={d.id} to={`/dashboards/${d.id}`} className="group">
            <Card className="h-full transition-colors group-hover:border-admin-primary/40">
              <CardHeader>
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-center gap-2">
                    <BarChart3 className="h-4 w-4 text-admin-primary" />
                    <CardTitle>{d.title}</CardTitle>
                  </div>
                  <ChevronRight className="h-4 w-4 text-admin-text-subtle group-hover:text-admin-primary" />
                </div>
              </CardHeader>
              <CardContent className="text-sm text-admin-text-secondary">
                <p>{d.description}</p>
                <p className="text-xs text-admin-text-subtle mt-3">
                  {d.charts.length} graf{d.charts.length === 1 ? "" : "er"}
                </p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
